export default function log(msg, level = 'Development') {
  if (
    process.env.NODE_ENV.toLowerCase() === 'development' ||
    process.env.REACT_APP_S3_ENV.toLowerCase() === 'development'
  ) {
    console.log(new Date().toISOString() + ' [' + level + ']: ', msg);
  }
}
